document.addEventListener("DOMContentLoaded", function () {
  const localeMap = {
    de: "de-DE",
    en: "en-US",
    fr: "fr-FR",
    no: "no-NO",
    it: "it-IT",
    sv: "sv-SE",
    es: "es-ES",
    da: "da-DK",
    pl: "pl-PL",
    pt: "pt-PT",
    cs: "cs-CZ",
    nl: "nl-NL",
  }

  const shopLocale = document.body.dataset.shopLocale?.toLowerCase() || navigator.language.split("-")[0]
  const intlLocale = localeMap[shopLocale] || "de-DE"

  const elements = document.querySelectorAll(".format-number")

  elements.forEach((el) => {
    const rawNumber = parseFloat(el.dataset.formatNumber)
    if (isNaN(rawNumber)) return

    const minFraction = parseInt(el.dataset.minFraction || "2", 10)
    const maxFraction = parseInt(el.dataset.maxFraction || "2", 10)

    const formatted = new Intl.NumberFormat(intlLocale, {
      minimumFractionDigits: minFraction,
      maximumFractionDigits: maxFraction,
    }).format(rawNumber)

    el.textContent = formatted
  })
})
